theme.accordion = (function() {
  function accordionBody(e) { 
    let faqContainer = e.querySelectorAll('.faq__list--item__button');
    faqContainer.forEach(function (list) {
      list.addEventListener("click", function (event) {
          let singleFaqItem = list.closest('.faq__list--item'),
              singleFaqItemBody = singleFaqItem.querySelector('.faq__body');
        
       		singleFaqItem.addEventListener(
                  "transitionend",
                  () => {
                    trapFocus(singleFaqItem);
                  },
                  { once: true }
             );
      
      		singleFaqItem.addEventListener("keyup", (evt) => {
              if (evt.code === "Escape") {
                singleFaqItem.classList.remove("active");
                list.setAttribute("aria-expanded", "false");
                slideUp(singleFaqItemBody);
                removeTrapFocus(singleFaqItem);
              }
            });
        
          if (singleFaqItem.classList.contains("active")) {
            singleFaqItem.classList.remove("active");
            list.setAttribute("aria-expanded", "false");
            slideUp(singleFaqItemBody);            
        
          } else {
            singleFaqItem.classList.add("active");
            list.setAttribute("aria-expanded", "true");
            slideDown(singleFaqItemBody);
            getSiblings(singleFaqItem).forEach(function (sibling) {
              let sibllingSingleAccordionBody = sibling.querySelector('.faq__body');
              sibling.classList.remove("active");
              sibling.querySelector('.faq__list--item__button').setAttribute("aria-expanded", "false");
              slideUp(sibllingSingleAccordionBody);
            });
          }
      });
      
    });
  }
  return accordionBody;
})();
